import ApplicationStore from '../../stores/ApplicationStore';
import getQuickstartUrl from '../../util/getQuickstartUrl';
import { useFluxible } from './useFluxible';
export var useQuickstartUrl = function (_a) {
    var quickstartId = _a.quickstartId, platformId = _a.platformId, versionId = _a.versionId, articleId = _a.articleId;
    var context = useFluxible();
    var appStore = context.getStore(ApplicationStore);
    return getQuickstartUrl({ quickstartId: quickstartId, platformId: platformId, versionId: versionId, articleId: articleId }, appStore.isFramedMode(), appStore.isSingleQuickstartMode());
};
